export const BASE_URL = 'https://barcode-api.kuarasoftware.es/';
// export const BASE_URL = 'http://localhost:3005/';
